import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { IResponse } from '@bt/shared';
import { AssetBalanceModel } from '../models/AssetBalance.model';
import { ExchangeWithdraw } from '../models';

@Injectable()
export class ExchangeService {

  constructor(private api: ApiService) {
  }

  public uriBuilder(): string {
    return "api/exchange";
  }

  /**
   * Получает балансы бирж
   */
  public getAllBalances(): Promise<IResponse<AssetBalanceModel[]>> {
    return this.api.get<AssetBalanceModel[]>(this.uriBuilder() + "/getBalances").toPromise();
  }

  /**
   * Получает стоимость всего баланса биржи
   */
  public getBalanceCost(): Promise<IResponse<number>> {
    return this.api.get<number>(this.uriBuilder() + "/getBalanceCost").toPromise();
  }

  /**
   * Проверяет доступность вывода средств из биржи
   */
  public checkWithdrawalAvailable(): Promise<IResponse<boolean>> {
    return this.api.get<boolean>(this.uriBuilder() + "/checkWithdrawalAvailable").toPromise();
  }

  /**
   * Создаёт запрос на вывод средств из бирж
   * @constructor
   */
  public CreateWithdrawRequest(): Promise<IResponse<boolean>> {
    return this.api.get<boolean>(this.uriBuilder() + "/createWithdrawRequest").toPromise();
  }

  /**
   * Получает список операций вывода из бирж
   */
  public getExchangeWithdraws(): Promise<IResponse<ExchangeWithdraw[]>> {
    return this.api.get<ExchangeWithdraw[]>(this.uriBuilder() + "/getWithdrawTransactions").toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/exchange.service.ts